
import debounce from 'lodash/debounce';
import { mmMatches } from '../utils/utils.matchmedia';
import Siema from 'siema';

let countersInitialised = false;

function countersAreInitialised() {
    return countersInitialised;
}

function activateCounter(index) {
    const logoCollectionCounters = document.querySelectorAll('.js-logo-collection-counter');

    // Remove the 'is-active' class for whichever counter is currently active.
    [...logoCollectionCounters].forEach(counter => {
        if(counter.classList.contains('is-active')) {
            counter.classList.remove('is-active');
        }

        // Add 'is-active' class to the slide that we just changed to.
        if(counter.getAttribute('data-controls-slide') == index) {
            counter.classList.add('is-active');
        }
    });
}

function showCounters() {
    if(mmMatches('small-tablet-max')) {

        if(!countersAreInitialised()) {
            // Grab all the carousel items.
            const logoCollectionItems = document.querySelectorAll('.js-logo-collection-item');

            const logoCollectionCountersEl = document.querySelector('.js-logo-collection-counters');

            // Loop through the slides and create a counter for each slide.
            for (let i = 0; i < logoCollectionItems.length; i++) {

                let logoCollectionCounter = document.createElement('li');
                logoCollectionCounter.classList.add('logo-collection__counter', 'js-logo-collection-counter');
                logoCollectionCounter.setAttribute('data-controls-slide', i);

                if(i == 0) {
                    logoCollectionCounter.classList.add('is-active');
                }

                logoCollectionCountersEl.appendChild(logoCollectionCounter);
            }

            countersInitialised = true;
        }
    }
}

function registerCounterClickEvents(carousel) {
    if(mmMatches('small-tablet-max')) {
        // Grab all the carousel items.
        const logoCollectionCounters = document.querySelectorAll('.js-logo-collection-counter');

        // Loop through the counters and add an event listener to go to the selected slide.
        [...logoCollectionCounters].forEach((counter, i) => {
            counter.addEventListener('click', () => {
                carousel.goTo(i, () => activateCounter(i));
            });
        });
    }
}

function disableButton(button) {
	if(button) {
		button.classList.add('is-disabled');
		button.disabled = true;
	}
}

function enableButton(button) {
	if(button) {
		button.classList.remove('is-disabled');
		button.disabled = false;
	}
}

const 	logoCollection = [...document.querySelectorAll('.js-logo-collection-carousel')];

logoCollection.forEach( item => {

    const   logoCarouselList = item.querySelector('.js-carousel-list'),
            logoCarouselItemsLength = [...logoCarouselList.children].length,
            prevButton = item.querySelector('.js-prev'),
            nextButton = item.querySelector('.js-next');

    if ( 
        mmMatches('small-tablet-max') && logoCarouselItemsLength > 1 ||
        mmMatches('tablet-max') && logoCarouselItemsLength > 2 ||
        mmMatches('desktop-max') && logoCarouselItemsLength > 3 ||
        mmMatches('desktop') && logoCarouselItemsLength > 5 ) {

    	const  logoCollectionCarousel = new Siema({
    		selector: logoCarouselList,
    		duration: 200,
    		easing: 'ease-out',
            perPage: {
                0: 1,
                580: 2,
    	        768: 3,
    	        1024: 5
    		},
    		startIndex: 0,
    		draggable: true,
    		multipleDrag: true,
    		threshold: 20,
    		loop: false,
    		onInit: () => {
                item.classList.add('is-carousel');
                logoCarouselList.classList.add('is-carousel');

                disableButton(prevButton);

                showCounters();
                window.addEventListener('resize', debounce(showCounters, 250));

            },
            onChange: () => {
                activateCounter(logoCollectionCarousel.currentSlide);

                const numberOfSlides = logoCollectionCarousel.innerElements.length;

                if(logoCollectionCarousel.currentSlide > 0) {
    				enableButton(prevButton);
    			} else {
    				disableButton(prevButton);
    			}

    			if(logoCollectionCarousel.currentSlide + logoCollectionCarousel.perPage == numberOfSlides) {
    				disableButton(nextButton);
    			} else {
    				enableButton(nextButton);
    			}
            }
    	});

        prevButton.addEventListener('click', e => {
            logoCollectionCarousel.prev();
        });
        nextButton.addEventListener('click', e => {
            logoCollectionCarousel.next();
        });

        registerCounterClickEvents(logoCollectionCarousel);
        window.addEventListener('resize', debounce(() => registerCounterClickEvents(logoCollectionCarousel), 250));
    }
});


